import React from 'react';

import TextParagraphIcon from '../../molecules/TextParagraphIcon';
import BotAnswer from '../../molecules/BotAnswer';

export default ({ reactions, placeholder, handleChange, handleBlur, removeReaction }) => (
	<div className="answerBuilder">
		<TextParagraphIcon classType="answerBuilder__answerText" icon="fa-comments" text="Bot answers:" />
		<div className="answerBuilder__container">
			<div className="answerBuilder__reaction">
				<form>
					<div className="answerBuilder__creator">
						{
							reactions.map((reaction, i) => (
								<BotAnswer
									key={i}
									answerNumber={`${i + 1}`}
									placeholder={placeholder}
									value={reaction}
									name={`${i}`}
									onChange={handleChange}
									handleBlur={handleBlur}
									onClick={e => removeReaction(i)}
									id='reactions'
									showDelete={reaction.length > 0}
								/>
							))
						}
					</div>
				</form>
			</div>
		</div>
	</div>
);



// WEBPACK FOOTER //
// ./src/redux/components/organisms/AnswerBuilder/AnswerBuilder.js